import { Divider } from '@material-ui/core';
import { Inline, Stack, useResponsiveValue } from '@superdispatch/ui';
import { ShipperRatingStatisticsDTO } from 'shared/modules/ratings/data/ShipperRatingDTO';
import { RatingSummaryItem } from 'shared/modules/ratings/RatingSummaryItem';

interface Props {
  data: ShipperRatingStatisticsDTO;
}

export function ShipperRatingStatistics({ data }: Props) {
  const isMobile = useResponsiveValue(true, false);
  const { ON_TIME_PAYMENT, GOOD_COMMUNICATION, ACCURATE_INFORMATION } = data;

  if (isMobile) {
    return (
      <Stack>
        <RatingSummaryItem
          label="On-Time Payment"
          count={ON_TIME_PAYMENT ?? 0}
        />

        <RatingSummaryItem
          label="Good Communication"
          count={GOOD_COMMUNICATION ?? 0}
        />

        <RatingSummaryItem
          label="Accurate Information"
          count={ACCURATE_INFORMATION ?? 0}
        />
      </Stack>
    );
  }

  return (
    <Inline space={['none', 'none', 'medium']} noWrap={true}>
      <RatingSummaryItem label="On-Time Payment" count={ON_TIME_PAYMENT ?? 0} />

      <Divider orientation="vertical" />

      <RatingSummaryItem
        label="Good Communication"
        count={GOOD_COMMUNICATION ?? 0}
      />

      <Divider orientation="vertical" />

      <RatingSummaryItem
        label="Accurate Information"
        count={ACCURATE_INFORMATION ?? 0}
      />
    </Inline>
  );
}
